import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    getPageContent,
    updateCurrentScreen,
    updateApplicant,
    updateApplicationStatus,
    updateApplicantStatus,
    updateApplicantStatusAsync,
    updateCurrentScreenAsync,
} from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import {
    selectApplicationData,
    selectApplicationStatus,
    selectApplicationError,
    initializeAsync,
    removeGuidanceAsync,
} from "./applicationSlice";

// Add custom imports here

import {
    Button,
    Box,
    Paper,
    Menu,
    MenuItem,
    Container,
    Typography,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Backdrop,
    CircularProgress,
    Alert,
    AlertTitle,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { NavigationTab } from "../../components/NavigationTab";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Footer } from "../../components/Footer";
import { PersonName } from "../../components/PersonName";
import { RadioButtons } from "../../components/InputField/RadioButtons";
import SliderComponent from "../../components/InputField/SliderComponent";

import { Address } from "../../components/Address";
import PlainTextField from "../../components/InputField/PlainTextField";
import { Income } from "../../components/Income";
import { Agent } from "../../components/Agent";
import NumberField from "../../components/InputField/Number";
import { Note } from "../../components/Note";
import { MultipleEmails } from "../../components/MultipleEmails";
import { Input } from "../../components/Input";
import { Occupants } from "../../components/Occupants";
import { Payment } from "../../components/PaymentGateway";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import * as util from "util"; // has no default export
import { inspect } from "util"; // or directly
import { Steps } from "./steps";
import { DesktopHeader } from "../../components/DesktopHeader";
import { useMediaQuery } from "react-responsive";
import { PlaidIncomeLink } from "../../components/PlaidIncomeLink";
import track, { useTracking } from "react-tracking";
import { skeleton } from "./skeleton";

const screenLabels = {
    "application-pre-qualification;creditScore": { label: "Credit score", order: 1 },
    "application-pre-qualification;householdIncome": { label: "Household income", order: 2 },
    "application-pre-qualification;filedBankruptcy": { label: "Filed bankruptcy", order: 3 },
    "application-pre-qualification;evicted": { label: "Evicted from a tenancy", order: 4 },
    "application-pre-qualification;sexOffender": { label: "Convicted as sex offender", order: 5 },
    "application-pre-qualification;ofac": { label: "OFAC list", order: 6 },
    "application-pre-qualification;results": { label: "Pre qualification results", order: 7 },
    "application-co-applicants;applicants": { label: "Co-applicants", order: 8 },
    "application-co-applicants;occupants": { label: "Children", order: 9 },
    "application-co-applicants;guarantor": { label: "Guarantor", order: 10 },
    "application-about;application-instruction": { label: "Application instruction", order: 11 },
    "application-about;identity-verification": { label: "Identity verification", order: 12 },
    "application-about;personName": { label: "Applicant Name", order: 13 },
    "application-about;additionalInformation": { label: "Applicant additional information", order: 14 },
    "application-about;preferredMoveInDate": { label: "Preferred move in date", order: 15 },
    "application-about;currentAddress": { label: "Current address", order: 16 },
    "application-finances;income": { label: "Income", order: 17 },
    "application-finances;balance": { label: "balance", order: 18 },
    "application-pets;pets": { label: "Pets", order: 19 },
    "application-sign;acknowledge": { label: "Acknowledgements", order: 20 },
    "application-Payment;payment": { label: "Credit Score", order: 21 },
};

const Application = () => {
    const [options, setOptions] = useState([]);
    const [steps, setSteps] = useState([]);
    const { Track, trackEvent } = useTracking({ page: "Application" });

    const [failedIDV, setFailedIDV] = useState(false);

    const data = useSelector(selectApplicationData);
    const status = useSelector(selectApplicationStatus);
    const error = useSelector(selectApplicationError);
    const dispatch = useDispatch();
    let { selectedTab, step } = useParams();
    const navigate = useNavigate();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    let guidance = data.guidance;

    const [currentTab, setCurrentTab] = useState(selectedTab ? selectedTab : "");
    const [currentStep, setCurrentStep] = useState(step ? step : "");
    const [loadingStep, setLoadingStep] = useState(false);

    const [stepValues, setStepValues] = useState(userDetails.applicant);

    const stepsRef = useRef();
    const isDesktop = useMediaQuery({ minWidth: 1180 });

    useEffect(() => {
        if (status === "idle") {
            dispatch(
                initializeAsync({
                    refreshSessionData,
                    applicantId: userDetails?.applicant.id,
                    applicationId: userDetails?.applicant.applicationId,
                    onComplete: () => {
                        userDetails = getUserDetailsNotAsync();
                        //setStepValues(userDetails.applicant);
                    },
                })
            );
            let status = [
                "Action Required",
                "Submitted",
                "In Progress",
                "Processing",
                "Cancelled",
                "Declined",
                "Approved",
            ];

            if (status.indexOf(userDetails?.applicant?.status) === -1) {
                if (userDetails?.applicant?.primaryApplicant) {
                    updateApplicationStatus(userDetails?.applicant?.applicationId, "In Progress");
                }
                updateApplicantStatus(userDetails?.applicant?.id, "In Progress");
            }
            // if (status.indexOf(userDetails?.applicant?.application?.status) === -1) {
            //     updateApplicationStatus(userDetails?.applicant?.applicationId, "In Progress");
            //     // updateApplicantStatus(userDetails?.applicant?.id, "In Progress");
            // }
        }
    }, [status, dispatch]);

    const getCurrentKey = () => {
        return currentTab + ";" + currentStep;
    };

    const updateScreen = () => {
        setTimeout(() => {
            if (userDetails.applicant.currentScreen !== "application" && currentTab && currentStep) {
                userDetails = updateCurrentScreen(userDetails, "application", getCurrentKey());

                setUserDetailsNotAsync(userDetails);
            }
        }, 100);
    };

    useEffect(() => {
        setTimeout(() => {
            document.querySelector(".inprogress-tab")?.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }, 1000);
    }, [currentTab]);

    useEffect(() => {
        if (userDetails?.applicant?.status !== "Action Required") {
            getDefaultOptions();
            updateScreen();
        } else {
            if (guidance !== undefined) {
                getDefaultOptions();
                updateScreen();
            }
        }
    }, [guidance]);

    const handleUpdateUserDetails = () => {
        userDetails = getUserDetailsNotAsync();
    };

    const handleIDVEvent = (event) => {
        userDetails = getUserDetailsNotAsync();
        if (event.detail.type !== "success") {
            setTimeout(() => {
                getDefaultOptions();
            }, 100);
        }
    };

    useEffect(() => {
        document.addEventListener("updateUserDetails", handleUpdateUserDetails);
        document.addEventListener("plaidIDVEvent", handleIDVEvent);
        return () => {
            document.removeEventListener("updateUserDetails", handleUpdateUserDetails);
            document.removeEventListener("plaidIDVEvent", handleIDVEvent);
        };
    }, []);

    const getDefaultOptions = () => {
        let options = stepsRef?.current?.options(getUserDetailsNotAsync(), currentTab, guidance);

        if (options) {
            setOptions(options);
            let stepsValue = [];
            for (let option of options) {
                if (option.steps?.length > 0) {
                    for (let step of option.steps) {
                        if (!step.skip) {
                            stepsValue.push({
                                optionValue: option.value,
                                key: option.value + ";" + step.step,
                                step: step,
                            });
                        }
                    }
                }
            }
            setSteps(stepsValue);

            if (!currentTab && options?.length > 0) {
                setCurrentTab(options[0].value);
            }

            if (!currentStep && stepsValue?.length > 0) {
                setCurrentStep(stepsValue[0].step.step);
            }
        }
    };

    const handleFormData = (key, data) => {
        userDetails = getUserDetailsNotAsync();
        let values = { ...userDetails.applicant };
        if (key) {
            if (key.indexOf(".") > -1) {
                let keys = key.split(".");
                let currentValue = values;
                for (let keyValue of keys) {
                    currentValue = currentValue[keyValue];
                }
                let parentValue = { ...values[keys[0]] };
                parentValue[keys[1]] = data;
                values[keys[0]] = parentValue;
            } else {
                values[key] = data;
            }
        } else {
            values = data;
        }

        setStepValues(values);
        userDetails.applicant = values;
        setUserDetailsNotAsync(userDetails);
        setTimeout(() => {
            getDefaultOptions();
        });

        handleTrack();
    };

    const getExternalId = () => {
        return userDetails.applicant.id + ";" + currentTab + "" + currentStep;
    };

    const handleTrack = (isNext) => {
        userDetails = getUserDetailsNotAsync();
        let values = { ...userDetails.applicant };

        if (!values.trackings) {
            values.trackings = [];
        }

        let existingRecord = values.trackings?.find((item) => item.externalId === getExternalId());
        let isChenged = false;
        if (!existingRecord) {
            isChenged = true;
            existingRecord = {
                applicantId: userDetails.applicant.id,
                currentTab: currentTab,
                currentStep: currentStep,
                status: "Started",
                startDate: new Date(),
                view: isDesktop ? "Desktop" : "Mobile",
                externalId: getExternalId(),
                name: screenLabels[currentTab + ";" + currentStep]?.label,
                order: screenLabels[currentTab + ";" + currentStep]?.order,
            };
        }
        if (isNext && existingRecord.status !== "Completed") {
            isChenged = true;
            existingRecord.endDate = new Date();
            existingRecord.status = "Completed";
        }
        if (isChenged) {
            trackEvent(existingRecord);
            let isFind = false;
            values.trackings = values.trackings.map((item) => {
                if (item.externalId === existingRecord.externalId) {
                    isFind = true;
                    return existingRecord;
                }

                return item;
            });

            if (!isFind) {
                values.trackings = [...values.trackings, existingRecord];
            }

            setStepValues(values);
            userDetails.applicant = values;
            setUserDetailsNotAsync(userDetails);
        }
    };

    const getFormData = (key) => {
        let values = { ...stepValues };
        if (key) {
            if (key.indexOf(".") > -1) {
                let keys = key.split(".");
                let currentValue = values;
                for (let keyValue of keys) {
                    currentValue = currentValue[keyValue];
                }
                return currentValue;
            } else {
                return values[key];
            }
        } else {
            return values;
        }
    };

    const getFooterProps = () => {
        let currentIndex = steps.findIndex((item) => item.key === getCurrentKey());
        let value = {};
        if (currentIndex > 0 && !dispalyTabAsGroup()) {
            value["hasBack"] = true;
        }
        value["hasNext"] = true;
        let currentStep = steps[currentIndex];
        value["isPaymentScreen"] = currentStep?.step?.isPaymentScreen;
        return value;
    };

    const handleOnClick = (nextStep) => {
        let currentIndex = steps.findIndex((item) => item.key === getCurrentKey());

        let currentStep = steps[currentIndex];

        let newIndex = steps.findIndex((item) => item.key === nextStep);

        let newStep = steps[newIndex];

        navigateToStep(currentStep, newStep);
    };

    const updateStatusToSubmitted = async () => {
        userDetails = await updateCurrentScreenAsync(userDetails, "application-completion", ``);
        userDetails.applicant.status = "Submitted";
        setUserDetailsNotAsync(userDetails);
        await updateApplicantStatusAsync(userDetails?.applicant?.id, "Submitted");
    };

    const handleNextClick = async () => {
        let currentIndex = steps.findIndex((item) => item.key === getCurrentKey());

        let currentStep = steps[currentIndex];
        let validated = validate(currentStep);
        userDetails = getUserDetailsNotAsync();
        if (validated) {
            if (currentIndex === steps.length - 1) {
                updateApplicant(userDetails.applicant, currentStep.key);
                setUserDetailsNotAsync(userDetails);
                if (currentStep?.step?.isPaymentScreen) {
                    let result = await currentStep?.step?.paymentRef?.current.submit();
                    handleTrack(true);
                    if (result === "Promocode applied") {
                        await updateStatusToSubmitted();
                        window.open("/application-completion", "_self");
                    }
                } else {
                    await updateStatusToSubmitted();
                    navigate("/application-completion", {
                        replace: true,
                    });
                    handleTrack(true);
                }
            } else {
                if (currentStep?.step?.isPaymentScreen) {
                    userDetails.applicant = stepValues;
                    updateApplicant(userDetails.applicant, currentStep.key);
                    setUserDetailsNotAsync(userDetails);
                    let result = await currentStep?.step?.paymentRef?.current.submit();
                    if (result === "Promocode applied") {
                        await updateStatusToSubmitted();
                        window.open("/application-completion", "_self");
                    }
                    handleTrack(true);
                } else {
                    let newStep = getNewStep(currentIndex);
                    navigateToStep(currentStep, newStep);
                    handleTrack(true);
                }
            }
        }
    };

    const getNewStep = (currentIndex, isBack) => {
        let currentTab = getCurrentTab();
        let newStep;
        if (currentTab.displayAsGroupingInDesktopView && isDesktop) {
            const indexCurrentStep = currentTab.steps.findIndex((step) => step.step === currentStep);
            if (!isBack) {
                newStep = steps[currentIndex + (currentTab.steps.length - indexCurrentStep)];
            } else {
                newStep = steps[currentIndex - (1 + indexCurrentStep)];
            }
        } else {
            newStep = !isBack ? steps[currentIndex + 1] : steps[currentIndex - 1];
        }
        if (
            newStep?.key === "application-finances;balance" &&
            (userDetails.applicant.plaidOtherVerified || userDetails.applicant.plaidIncomeVerified)
        ) {
            const newStepIndex = steps.findIndex((step) => step.key === newStep.key);
            newStep = !isBack ? steps[newStepIndex + 1] : steps[newStepIndex - 1];
        }
        if (
            newStep?.key === "application-about;identity-verification" &&
            userDetails?.applicant?.plaidIdentityVerified
        ) {
            const newStepIndex = steps.findIndex((step) => step.key === newStep.key);
            newStep = !isBack ? steps[newStepIndex + 1] : steps[newStepIndex - 1];
        }

        return newStep;
    };

    const validate = (currentStep) => {
        let currentTab = getCurrentTab();
        let hasError = false;
        if (currentTab.displayAsGroupingInDesktopView && isDesktop) {
            for (let step of currentTab.steps) {
                for (let i = 0; i < step.refs?.length; i++) {
                    if (step?.refs[i]?.current) {
                        if (!step?.refs[i]?.current?.validate()) {
                            hasError = true;
                        }
                    }
                }
            }
        } else {
            for (let i = 0; i < currentStep?.step?.refs?.length; i++) {
                if (currentStep?.step?.refs[i]?.current) {
                    if (!currentStep?.step?.refs[i]?.current?.validate()) {
                        hasError = true;
                    }
                }
            }
        }

        return !hasError;
    };

    const handleBackClick = () => {
        let currentIndex = steps.findIndex((item) => item.key === getCurrentKey());
        if (currentIndex === 0) {
            return;
        }
        let currentStep = steps[currentIndex];
        let newStep = getNewStep(currentIndex, true);

        navigateToStep(currentStep, newStep);
    };

    const navigateToStep = (currentStep, newStep) => {
        let tab = newStep.key.split(";")[0];
        let step = newStep.key.split(";")[1];
        let currentTab = getCurrentTab();
        let guidances = getGuidanceRecords();

        dispatch(removeGuidanceAsync({ records: guidances?.filter((item) => item.displayOnce) }));

        userDetails = getUserDetailsNotAsync();
        userDetails.applicant = stepValues;
        //Had to change currentstep.key to just step
        updateApplicant(userDetails.applicant, currentStep.key, currentTab.displayAsGroupingInDesktopView && isDesktop);
        setCurrentTab(tab);
        setCurrentStep(step);

        userDetails = updateCurrentScreen(userDetails, "application", `${tab};${step}`);
        setUserDetailsNotAsync(userDetails);

        navigate(`/application/${tab}/${step}`);
        setLoadingStep(true);
        setTimeout(() => {
            getDefaultOptions();
            setLoadingStep(false);
        }, 200);
    };

    const getCurrentStep = () => {
        return steps.find((item) => item.key === getCurrentKey());
    };

    const getCurrentTab = () => {
        return options.find((item) => item.value === currentTab);
    };

    const getCurrentStepIndex = () => {
        let tab = options.find((item) => item.value === currentTab);
        if (tab.steps?.length > 0) {
            return tab.steps.findIndex((item) => item.step === currentStep);
        }
        return 0;
    };

    const dispalyTabAsGroup = () => {
        let currentTab = getCurrentTab();
        return currentTab.displayAsGroupingInDesktopView && isDesktop;
    };

    const getGuidanceRecords = () => {
        if (guidance?.length > 0) {
            let guidanceToDisplay = guidance.filter((item) => {
                if (item?.location) {
                    let tab;
                    let step;
                    if (item?.location?.startsWith("/")) {
                        let splittedLocation = item?.location.split("/");
                        if (splittedLocation.length === 3) {
                            tab = splittedLocation[1];
                            step = splittedLocation[2];
                        }
                    } else {
                        let splittedLocation = item?.location.split("/");
                        if (splittedLocation.length === 2) {
                            tab = splittedLocation[0];
                            step = splittedLocation[1];
                        }
                    }
                    if (tab && step) {
                        if (dispalyTabAsGroup()) {
                            return currentTab === tab;
                        } else {
                            return currentTab === tab && currentStep === step;
                        }
                    }
                }
                return false;
            });

            return guidanceToDisplay;
        }
        return [];
    };

    const createMarkup = (text) => {
        return { __html: text };
    };

    const displayGuidance = () => {
        let guidanceToDisplay = getGuidanceRecords();
        if (guidanceToDisplay?.length > 0) {
            return guidanceToDisplay.map((guidance) => (
                <>
                    <Alert sx={{ mb: "1rem" }} severity={guidance.type?.toLowerCase()}>
                        {guidance.title && <AlertTitle>{guidance.title}</AlertTitle>}
                        <div dangerouslySetInnerHTML={createMarkup(guidance.message)}></div>
                    </Alert>
                </>
            ));
        }
        return "";
    };

    let body = (
        <Track>
            <>
                {status === "idle" || options?.length === 0 ? (
                    <>
                        {/* <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
                            <CircularProgress color="inherit" />
                        </Backdrop> */}
                        {skeleton(userDetails, isDesktop)}
                        <Steps
                            ref={stepsRef}
                            handleFormData={handleFormData}
                            getFormData={getFormData}
                            stepValues={stepValues}
                            handleNextClick={handleNextClick}
                            userDetailsRecord={userDetails}></Steps>
                    </>
                ) : (
                    <>
                        <Container>
                            {userDetails.applicant && (
                                <DesktopHeader applicant={userDetails.applicant} isDesktop={isDesktop}></DesktopHeader>
                            )}
                            <Grid sx={{ width: "100%" }} container spacing={isDesktop ? 3 : 0}>
                                <Grid sx={{ pl: { lg: "0" } }} item xs={12} lg={4}>
                                    <NavigationTab
                                        options={options}
                                        selected={currentTab}
                                        selectedValue={getCurrentTab()}
                                        label={getCurrentTab().heading}
                                        totalStep={getCurrentTab().steps?.length}
                                        currentStepIndex={getCurrentStepIndex()}
                                        hideHeading={getCurrentTab().hideHeading}
                                        orientation={isDesktop ? "vertical" : ""}
                                        onClick={handleOnClick}></NavigationTab>
                                </Grid>
                                <Grid sx={{ pr: "0" }} item xs={12} lg={8}>
                                    <Card
                                        sx={{
                                            width: "100%",
                                            p: "16px",
                                            mt: { xs: "16px", lg: "0px" },
                                        }}>
                                        <CardContent sx={{ width: "100%" }}>
                                            {displayGuidance()}
                                            {!dispalyTabAsGroup() && (
                                                <>
                                                    <Grid
                                                        container
                                                        justifyContent={"space-between"}
                                                        alignItems={"center"}>
                                                        <Grid item>
                                                            <Typography
                                                                color="text.primary"
                                                                variant="h5"
                                                                component="h6"
                                                                sx={{ marginBottom: "10px" }}>
                                                                <b>{getCurrentStep()?.step?.heading}</b>
                                                            </Typography>
                                                            {getCurrentStep()?.step?.helpText && (
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ marginBottom: "10px" }}>
                                                                    {getCurrentStep()?.step?.helpText}
                                                                </Typography>
                                                            )}
                                                        </Grid>
                                                        {getCurrentStep()?.step.action && (
                                                            <Grid item>{getCurrentStep()?.step.action}</Grid>
                                                        )}
                                                    </Grid>

                                                    {getCurrentStep()?.step?.subheading && (
                                                        <Typography
                                                            sx={{ mt: 1, mb: 1 }}
                                                            color="text.secondary"
                                                            variant="h6"
                                                            component="h6">
                                                            {getCurrentStep()?.step?.subheading}
                                                        </Typography>
                                                    )}
                                                </>
                                            )}

                                            {!loadingStep && !dispalyTabAsGroup() && getCurrentStep()?.step?.body && (
                                                <Box sx={{ mt: "10px" }}>{getCurrentStep()?.step?.body}</Box>
                                            )}
                                            {!loadingStep && dispalyTabAsGroup() && (
                                                <>
                                                    {getCurrentTab()?.steps.map((step, index) => (
                                                        <>
                                                            <Grid
                                                                container
                                                                justifyContent={"space-between"}
                                                                alignItems={"center"}>
                                                                <Grid item>
                                                                    <Typography
                                                                        color="text.primary"
                                                                        variant="h5"
                                                                        component="h6">
                                                                        <b>{step?.heading}</b>
                                                                    </Typography>
                                                                </Grid>
                                                                {step.action && <Grid item>{step.action}</Grid>}
                                                            </Grid>

                                                            {step?.subheading && (
                                                                <Typography
                                                                    sx={{
                                                                        mt: 1,
                                                                        mb: 1,
                                                                    }}
                                                                    color="text.secondary"
                                                                    variant="h6"
                                                                    component="h6">
                                                                    {step?.subheading}
                                                                </Typography>
                                                            )}
                                                            <Box
                                                                sx={{
                                                                    mt: "10px",
                                                                }}>
                                                                {step?.body}
                                                            </Box>
                                                            {index !== getCurrentTab()?.steps.length - 1 && (
                                                                <Divider
                                                                    sx={{
                                                                        marginY: "16px",
                                                                    }}></Divider>
                                                            )}
                                                        </>
                                                    ))}
                                                </>
                                            )}
                                            <Box
                                                sx={{
                                                    display: !getCurrentStep()?.step?.hideFooter ? "block" : "none",
                                                }}>
                                                <Divider sx={{ marginY: "16px" }}></Divider>
                                                <Footer
                                                    {...getFooterProps()}
                                                    onNextClick={handleNextClick}
                                                    onBackClick={handleBackClick}></Footer>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Container>
                    </>
                )}
                <Steps
                    ref={stepsRef}
                    handleFormData={handleFormData}
                    getFormData={getFormData}
                    stepValues={stepValues}
                    handleNextClick={handleNextClick}
                    userDetailsRecord={userDetails}></Steps>
            </>
        </Track>
    );

    return getPageContent(body, status, error);
};

export { Application };
